import { render } from "./Events.vue?vue&type=template&id=01132ec7&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=01132ec7&scoped=true&lang=scss"
import "./Events.vue?vue&type=style&index=1&id=01132ec7&lang=css"

import exportComponent from "/Users/kovacsistvan/develop/segito-kezek/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01132ec7"]])

export default __exports__